import React from 'react';

import { MDText } from 'i18n-react';

import { Toggle } from '@motorway/mw-highway-code/alpha';

import LocalTexts from './CookiePreferencesTexts.json';

import styles from './CookiePreferences.module.scss';

const LocalT = new MDText(LocalTexts);

export type CookiePreferencesProps = {
  analyticsEnabled: boolean;
  marketingEnabled: boolean;
  onAnalyticsToggle: () => void;
  onMarketingToggle: () => void;
};

export const CookiePreferences = ({
  analyticsEnabled,
  marketingEnabled,
  onAnalyticsToggle,
  onMarketingToggle,
}: CookiePreferencesProps) => (
  <section className={styles.preferences}>
    <h2 className={styles.sectionHeading}>{LocalT.translate('heading')}</h2>
    <div className={styles.controls}>
      <Toggle
        defaultChecked
        disabled
        showLabel
        id="necessary"
        label={<span className={styles.label}>
          <span className={styles.toggleHeading}>{LocalT.translate('toggles.necessary.label')}</span>
          <span>{LocalT.translate('toggles.necessary.description')}</span>
        </span>
        }
      />
      <Toggle
        showLabel
        formProps={{
          input: {
            checked: marketingEnabled,
            onChange: onMarketingToggle,
          },
        }}
        id="marketing"
        label={<span className={styles.label}>
          <span className={styles.toggleHeading}>{LocalT.translate('toggles.marketing.label')}</span>
          <span>{LocalT.translate('toggles.marketing.description')}</span>
        </span>}
      />
      <Toggle
        showLabel
        formProps={{
          input: {
            checked: analyticsEnabled,
            onChange: onAnalyticsToggle,
          },
        }}
        id="analytics"
        label={<span className={styles.label}>
          <span className={styles.toggleHeading}>{LocalT.translate('toggles.analytics.label')}</span>
          <span>{LocalT.translate('toggles.analytics.description')}</span>
        </span>}
      />
    </div>
  </section>
);
